import React, { useCallback, useEffect, useMemo } from 'react';

import {
	HeaderLayout,
	MeetingSearch,
	User,
	AppIcon,
} from '@components';

import './AppPageHeader.scss';
import { useUserStoreContext } from '@store';
import { apiInstance, MeetingListSearchQuery } from '@api';
import { useHistory } from "react-router-dom";
import { routes } from '@routes';


interface AppPageHeaderProps {
	changeSearchQuery: (s: MeetingListSearchQuery) => void,
	defaultSearchValue: MeetingListSearchQuery,
}

function AppPageHeader(props: AppPageHeaderProps): JSX.Element {
	const {
		changeSearchQuery,
		defaultSearchValue,
	} = props;

	const { dispatch, state: UserStoreState } = useUserStoreContext();
	const history = useHistory();

	const leadingView = useMemo(() => {
		const clickable = history.location.pathname != routes.index.path;
		return <AppIcon clickable={clickable} />;
	}, [history]);

	const mainView = useMemo(() => {
		return (
			<MeetingSearch
				onChangeSearch={changeSearchQuery}
				initialValue={defaultSearchValue}
				placeholder="Поиск собраний"
				className="page__search"
			/>
		);
	}, [changeSearchQuery, defaultSearchValue]);

	const fetchAvatar = useCallback(async () => {
		if (UserStoreState && !UserStoreState.avatarSrc) {
			const email = UserStoreState.user.profile.email;
			const avatar = await apiInstance.getParticipantAvatarByEmail(email);
			if (avatar) {
				dispatch({
					type: 'SET_AVATAR_SRC',
					payload: URL.createObjectURL(avatar.data),
				});
			}
		}
	}, [UserStoreState, dispatch]);

	useEffect(() => {
		fetchAvatar();
	}, [fetchAvatar]);

	const trailingView = useMemo(() => {		
		return (UserStoreState && <>
			<User name={UserStoreState.user.profile.name} avatarSrc={UserStoreState.avatarSrc} className="page__user" />
		</>);
	}, [UserStoreState]);

	return (
		<HeaderLayout
			leading={leadingView}
			content={mainView}
			trailing={trailingView}
		/>
	);
}

export {AppPageHeader};